import React from 'react'

const FallBackLoader = () => {
  return (
    <div className='items-center justify-center w-full  flex h-[90vh]'>
      <div className="w-8 h-8 border-b-2 rounded-full animate-spin border-primary2" />
    </div>
  )
}

export default FallBackLoader